// True if `currentUserId` is the payer or in the participants list.
export const isParty = (expense, currentUserId) => {
  if (!expense || !currentUserId) return false;
  if (expense.paidByUserId === currentUserId) return true;
  return Array.isArray(expense.participants)
    && expense.participants.some(p => p?.userId === currentUserId);
};

// True if the expense involves only {currentUserId, friendId, paidByUserId}
// — i.e. no third person is on the expense.
export const isOneToOneWith = (expense, currentUserId, friendId) => {
  if (!isParty(expense, currentUserId)) return false;
  if (!isParty(expense, friendId)) return false;
  const involved = new Set();
  if (expense.paidByUserId) involved.add(expense.paidByUserId);
  (expense.participants || []).forEach(p => { if (p?.userId) involved.add(p.userId); });
  const accepted = new Set([currentUserId, friendId, expense.paidByUserId].filter(Boolean));
  for (const id of involved) {
    if (!accepted.has(id)) return false;
  }
  return true;
};

export const filterOneToOneExpenses = (expenses, currentUserId, friendId) =>
  (expenses || []).filter(e => isOneToOneWith(e, currentUserId, friendId));
